<template>
  <div
    v-if="isOpen"
    class="aff-rules-backdrop"
    tabindex="-1"
    role="dialog"
    @click.self="accept"
  >
    <div class="aff-rules-modal" role="document">
      <div class="aff-rules-header">
        <div class="d-flex align-items-center gap-2">
          <div class="aff-rules-icon">
            <i class="material-icons">gavel</i>
          </div>
          <div>
            <p class="aff-rules-eyebrow mb-0">Programa de afiliados</p>
            <h5 class="mb-0 text-white">Regras importantes</h5>
          </div>
        </div>
      </div>

      <div class="aff-rules-body">
        <p class="aff-rules-lead">
          Antes de divulgar, leia com atenção. Ao continuar, você declara que entendeu
          e aceita estas regras.
        </p>

        <ul class="aff-rules-list">
          <li>
            <strong>Comissão:</strong> você ganha na
            <strong>1ª taxa de publicação</strong> ou no
            <strong>1º plano</strong> de cada indicado cadastrado pelo seu link.
          </li>
          <li>
            <strong>Saque:</strong> o valor fica no saldo de comissões em
            <strong>Meus Indicados</strong>. Mínimo
            <strong>R$ 100,00</strong> via Pix (nome + chave). Taxa de saque R$ 4,50.
            Até 1 solicitação por semana. Não usa a Carteira do Sistema.
          </li>
          <li>
            <strong>Proibido:</strong> usar o próprio link para se autoindicar,
            criar contas fictícias, ou qualquer fraude para gerar comissão indevida.
          </li>
          <li>
            <strong>Monitoramento:</strong> cadastros, pagamentos e saques ficam
            registrados em logs. Conduta irregular é identificada pela equipe.
          </li>
          <li>
            <strong>Consequência:</strong> em caso de abuso, a comissão
            <strong>não é paga</strong> e a conta pode ser
            <strong>removida do programa de afiliados e da plataforma</strong>
            (ação manual da equipe Rifa365).
          </li>
        </ul>

        <div class="aff-rules-notice">
          <i class="material-icons">info</i>
          <span>
            Os Termos de Uso serão atualizados com estas regras. Enquanto isso,
            elas já valem para quem participa do programa.
          </span>
        </div>

        <button type="button" class="btn aff-rules-btn w-100 mb-0" @click="accept">
          Li e concordo com as regras
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = "seen_affiliate_rules_v1";

export default {
  name: "AffiliateRulesModal",
  props: {
    isOpen: { type: Boolean, default: false },
  },
  methods: {
    accept() {
      try {
        localStorage.setItem(STORAGE_KEY, "1");
      } catch (e) {
        /* ignore */
      }
      this.$emit("accept");
      this.$emit("close");
    },
  },
};

export { STORAGE_KEY as AFFILIATE_RULES_STORAGE_KEY };
</script>

<style scoped>
.aff-rules-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10050;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.aff-rules-modal {
  width: min(520px, 100%);
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
}
.aff-rules-header {
  padding: 1.15rem 1.35rem;
  background: linear-gradient(135deg, #661cb0 0%, #8b3dd4 45%, #e41b80 100%);
}
.aff-rules-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.aff-rules-eyebrow {
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.8);
}
.aff-rules-body {
  padding: 1.25rem 1.35rem 1.4rem;
}
.aff-rules-lead {
  font-size: 0.9rem;
  color: #475569;
  margin-bottom: 1rem;
}
.aff-rules-list {
  margin: 0 0 1rem;
  padding-left: 1.1rem;
  color: #334155;
  font-size: 0.875rem;
  line-height: 1.5;
}
.aff-rules-list li {
  margin-bottom: 0.65rem;
}
.aff-rules-notice {
  display: flex;
  gap: 0.55rem;
  align-items: flex-start;
  padding: 0.75rem 0.85rem;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 0.8rem;
  color: #64748b;
  margin-bottom: 1rem;
}
.aff-rules-notice .material-icons {
  font-size: 18px;
  color: #7b23d3;
}
.aff-rules-btn {
  background: linear-gradient(135deg, #661cb0 0%, #e41b80 100%) !important;
  color: #fff !important;
  font-weight: 700 !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 0.75rem 1rem !important;
}
.gap-2 {
  gap: 0.5rem;
}
</style>
